import { useCallback } from "react";
import { prepareFilterQuery } from "../../components/filter/utils";
import AppAPI from "../api";
import { useAppSelector } from "../store";

interface GetDataProps {
  filter?: any;
  page?: number;
}

export default function useTableData() {
  const state = useAppSelector(store => store.AppSlice)
  const [getTableData] = AppAPI.useLazyGetTableDataQuery()

  const getData = useCallback((props: GetDataProps) => {
    const stateProps = {
      filter: prepareFilterQuery(state.filter),
      page: state.pagination?.currentPage
    }

    getTableData({ ...stateProps, ...props })
  }, [getTableData, state.filter, state.pagination?.currentPage])

  return getData
}
